import { render } from "./SidebarView.vue?vue&type=template&id=66c2369f&lang=true"
import script from "./SidebarView.vue?vue&type=script&lang=js"
export * from "./SidebarView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\webDesign\\trello-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__